import { store } from "../store/store";
import { showSnackbar } from "../store/slice/snackbarSlice";
// import i18n from "../plugins/i18n";
import { auth, qix } from "@qlik/api";
import type { HostConfig } from "@qlik/api/auth";
import type { OpenAppSessionProps } from "@qlik/api/qix";
import { CYBER_CONFIG } from "../constants/cyberConfig";

// Track if host config has been set
let isHostConfigSet = false;

export async function qlikApp(config: HostConfig, appId: OpenAppSessionProps): Promise<any> {
    try {
        // Only set default host config once
        if (!isHostConfigSet) {
            auth.setDefaultHostConfig(config);
            isHostConfigSet = true;
        }
        const appSession = qix.openAppSession(appId);
        const events = appSession.onWebSocketEvent((event) => {
            if (event.eventType === "suspended") {
                console.log("Session timeout occur at", new Date());
                store.dispatch(showSnackbar({reason: "suspended", message: CYBER_CONFIG.sessionTimeoutMessage}));
            }
        });
        const app = await appSession.getDoc();
        // console.log("Session started at", new Date());
        return app;
    } catch (error:any) {
        store.dispatch(showSnackbar({ reason: "error", message: CYBER_CONFIG.loadQlikErrorMessage }));
        throw new Error("Error opening qlik app: ", error);
    }

}

export default {
    qlikApp,
};